import React,{useEffect, useState} from 'react'
import {
  MDBCard,
  MDBCardBody,
  MDBCardText,
  MDBInputGroup,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from "mdb-react-ui-kit";
import icon1 from '../../src/img/GroupCircleicon1.png'
import icon2 from "../../src/img/GroupCircleicon2.png"
import icon3 from "../../src/img/GroupCircleicon3.png"
import greyBubbles from '../img/graytopcirclesPC.png'
import prupleBubbles from '../img/purpleCirclesTopTablet .png'

export const PelvicProgramBanner3 = () => {
  const getWindowDimensions = () => {
    const { innerWidth: width } = window;
    return {
      width,
    };
  };

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });
  return (
    <div>
    <div className='pelvic-program-banner-3'>
      <div className='text-center pt-banner-3'>
        <h3 className='text-al fs-48-32'>It’s <span className='underline-purple m-0'>Not</span> All in Your Head</h3>
        <p className='text-dm bg-text-purple mx-auto mt-5 fs-24-16'> 1 in 3 women suffer from incontinence. </p>
        <p className='text-dm bg-text-purple-two mx-auto fs-24-16'>1 in 7 suffer from painful sex.</p>
        <div className='mt-4'>
        <p className='text-dm fs-24-16 px-4'>You don't have to live with ongoing pelvic or hip pain when sitting, burning vaginal pain during sex, the <br className='no-mobile no-ipad'/>urge to pee umpteen times, or suffer with constipation and abdominal bloating.</p>
        </div>
      </div>
      <div className='mt-5'>
      <h3 className='text-al fs-30-22 text-center mt-help-class'>Who does PelvicSense Help? </h3>
      <MDBRow className='padding-cards-program'>
        <MDBCol size='12' md="12" lg="4" order="1" className='bg-grey-pelvic-program'>
        <div className='d-flex justify-content-center'>
        <div>
        <div className='circle-controller-program'>
        <div className='circle-program-1 mt-4'>
        <img src={icon3} className="circle-image-program"></img>
        </div>
        </div>
        <div className='mt-5 text-center'>
        <h5 className='up-text text-al fs-24-20'>Pelvic Floor Dysfunction</h5>
        <p className='px-3 mt-1 text-dm'>From teenagers to women of all ages who experience discomfort with sex, bladder urgency/frequency, leak during activities, or suffer with constipation and abdomnial bloating.</p>
        </div>
        </div>
        </div>
        </MDBCol>
        <MDBCol size='12' md="12" lg="4" order="2" className='bg-grey-pelvic-program' >
        <div className='circle-controller-program'>
        <div className='circle-program-2 mt-4'>
          <img src={icon2} className="circle-image-program-two"></img>
        </div>
        </div>
        <div className='mt-5 text-center'>
          <h5 className='up-text text-al fs-24-20'>Chronic Pelvic Pain</h5>
          <p className='px-3 mt-1 text-dm'> Women diagnosed with Endometriosis, Vulvodynia, Pudenal Neuralgia, Vaginismus, Chronic Pelvic Pain, Interstitial Cystitis, PGAD, Constipation, Irritable Bowel Syndrome, Lower Back/Sacroiliac/Hip Pain, Sitting Pain.</p>
        </div>
        </MDBCol>
        <MDBCol size='12' md="12" lg="4" order="3" className='bg-grey-pelvic-program'>
        <div className='circle-controller-program'>
        <div className='circle-program-3 mt-4'>
          <img src={icon1} className="circle-image-program-three"></img>
        </div>
        </div>
        <div className='mt-5 text-center'>
          <h5 className='up-text text-al fs-24-20'>Pelvic Anxiety</h5>
          <p className='px-3 mt-1 text-dm'>1 out of 3 women suffer in silence with their pelvic issues. Doing a self-care program and talking openly about pelvic issues can help you, a friend, or family find hope and healing.</p>
          </div>
        </MDBCol>
      </MDBRow>
      </div>
    </div>
      <div>
        <img src={windowDimensions.width <= 840 ? prupleBubbles : greyBubbles} className="greyBubles"></img>
      </div>
    </div>
  )
}
